var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { idfwbonavigation: _vm.tabcouponnode.idfwbonavigation.toString() }
    },
    [
      _c(
        "v-container",
        { staticClass: "tab-coupon", attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            {
              staticClass: "v-tabs-wrapper clearfix",
              class: { tabs_home: _vm.currentidfwbonavigation === "top" },
              attrs: { row: "" }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _vm.currentidfwbonavigation === "top"
                    ? _c(
                        "v-tabs",
                        { attrs: { "fixed-tabs": "", centered: _vm.centered } },
                        [
                          _vm.isRecommendedEventsVisible
                            ? _c(
                                "v-tab",
                                {
                                  class: [
                                    "tab",
                                    {
                                      active:
                                        _vm.selectedTab.idfwbonavigation ===
                                        "recommended"
                                    }
                                  ],
                                  attrs: { idfwbonavigation: "recommended" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.selectTab("recommended")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BettingOffer.tabCoupon.recommended"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.tabs, function(tab, index) {
                            return _c(
                              "v-tab",
                              {
                                key: index,
                                class: [
                                  "tab",
                                  {
                                    active:
                                      tab.idfwbonavigation ===
                                      _vm.selectedTab.idfwbonavigation
                                  },
                                  {
                                    tabLive: tab.idfwbonavigationtypes.includes(
                                      "INPLAYPERSPORTTYPE"
                                    )
                                  }
                                ],
                                attrs: {
                                  idfwbonavigation: tab.idfwbonavigation.toString()
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.selectTab(tab.idfwbonavigation)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(tab.name))]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isRootSportsNavigation
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "tabs_holder",
                          class: { moreThenFive: _vm.tabs.length > 5 },
                          attrs: { "fixed-tabs": "", centered: _vm.centered }
                        },
                        _vm._l(_vm.tabs, function(tab, index) {
                          return _c(
                            "v-tab",
                            {
                              key: index,
                              class: [
                                "tab",
                                {
                                  active:
                                    tab.idfwbonavigation ===
                                    _vm.selectedTab.idfwbonavigation
                                }
                              ],
                              attrs: {
                                idfwbonavigation: tab.idfwbonavigation.toString()
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.selectTab(tab.idfwbonavigation)
                                }
                              }
                            },
                            [_vm._v(_vm._s(tab.name))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showSportsFilter
            ? _c(
                "v-tabs",
                {
                  staticClass: "sports-filter small",
                  attrs: {
                    xs12: "",
                    "fixed-tabs": "",
                    "align-with-title": "",
                    "next-icon": "chevron_right",
                    "prev-icon": "chevron_left",
                    "show-arrows": ""
                  }
                },
                [
                  _vm.brandTemplate !== "generic_2"
                    ? _c("span", { staticClass: "sports-filter-label" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BettingOffer.tabCoupon.SportsFilter.Label")
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.availablePrematchSports.length
                    ? _c(
                        "v-tab",
                        {
                          class: [
                            "sport",
                            "tab",
                            "all-sports",
                            { active: _vm.allSportsActive }
                          ],
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectAllSports()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("BettingOffer.tabCoupon.allSports"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.availablePrematchSports, function(sport, index) {
                    return _c(
                      "v-tab",
                      {
                        key: index,
                        class: [
                          "sport",
                          "tab",
                          {
                            active:
                              _vm.selectedSports.indexOf(sport.idfosporttype) >
                              -1
                          }
                        ],
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return function() {
                              _vm.toggleSport(sport.idfosporttype)
                            }.apply(null, arguments)
                          }
                        }
                      },
                      [
                        (_vm.brandLayout === "generic" &&
                          _vm.brandTemplate !== "generic_2") ||
                        _vm.brandKey === "sb" ||
                        _vm.brandKey === "mav"
                          ? _c("icon", {
                              attrs: {
                                colorName: "black",
                                name:
                                  "icon-" +
                                  sport.idfosporttype
                                    .split(" ")
                                    .join("")
                                    .toLowerCase()
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandLayout !== "generic" &&
                        _vm.brandKey !== "sb" &&
                        _vm.brandKey !== "mav"
                          ? [
                              _vm._v(
                                _vm._s(sport.fosporttypename.toLowerCase())
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brandLayout === "generic" &&
                        _vm.brandTemplate === "generic_2"
                          ? [
                              _vm._v(
                                _vm._s(sport.fosporttypename.toLowerCase())
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isInPlayBoNode && _vm.selectedTab
            ? _c(
                "div",
                {
                  staticClass: "tab-content",
                  class: { recommendedLoading: _vm.isRecommendedEventsLoading },
                  attrs: {
                    idfwbonavigation: _vm.selectedTab.idfwbonavigation.toString()
                  }
                },
                [
                  _vm.selectedTabMarketgroups &&
                  _vm.selectedTabMarketgroups.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "marketgroups",
                          class: {
                            selected_sport_active: _vm.selectedSports.length > 0
                          }
                        },
                        [
                          _vm.isOddsBoost
                            ? _c(
                                "div",
                                _vm._l(_vm.selectedTabMarketgroups, function(
                                  mg,
                                  index
                                ) {
                                  return _c("odds-boost-market-group", {
                                    key: mg.idfwmarketgroup,
                                    attrs: {
                                      idfwmarketgroup: mg.idfwmarketgroup,
                                      "events-grouping":
                                        _vm.selectedTab.displaytemplatename,
                                      "selected-sports": _vm.selectedSports,
                                      maxevents: _vm.selectedTab.maxitems || 0,
                                      "all-sports-active": _vm.allSportsActive,
                                      "show-marketgroup-name": false,
                                      counter: index,
                                      hideliveevents: _vm.selectedTab.overlay,
                                      isOddsBoost: _vm.isOddsBoost
                                    }
                                  })
                                }),
                                1
                              )
                            : _c(
                                "div",
                                _vm._l(_vm.selectedTabMarketgroups, function(
                                  mg,
                                  index
                                ) {
                                  return _c("market-group", {
                                    key: mg.idfwmarketgroup,
                                    attrs: {
                                      idfwmarketgroup: mg.idfwmarketgroup,
                                      marketGroupData: mg.marketGroup,
                                      "events-grouping":
                                        _vm.selectedTab.displaytemplatename,
                                      "selected-sports": _vm.selectedSports,
                                      maxevents: _vm.selectedTab.maxitems || 0,
                                      "all-sports-active": _vm.allSportsActive,
                                      "show-marketgroup-name": false,
                                      counter: index,
                                      hideliveevents: _vm.selectedTab.overlay,
                                      isOddsBoost: _vm.isOddsBoost
                                    }
                                  })
                                }),
                                1
                              )
                        ]
                      )
                    : !(
                        _vm.selectedTabMarketgroups &&
                        _vm.selectedTabMarketgroups.length > 0
                      ) && !_vm.isRecommendedEventsLoading
                    ? _c("div", { staticClass: "marketgroups" }, [
                        _vm.isOddsBoost
                          ? _c("div", { staticClass: "ob_noevents" }, [
                              _vm.brandKey === "sb"
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.mediaServer(
                                        "/static/brand-img/sb/OddsBoost-noEvents.svg"
                                      ),
                                      alt: "noevents"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.brandKey !== "sb"
                                ? _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Sports.NoAvailableEvents"))
                                    )
                                  ])
                                : _vm._e()
                            ])
                          : _c("div", { staticClass: "noevents" }, [
                              _vm.brandKey === "sb"
                                ? _c("img", {
                                    attrs: {
                                      src: _vm.mediaServer(
                                        "/static/brand-img/sb/noEvents.svg"
                                      ),
                                      alt: "noevents"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.brandKey !== "sb"
                                ? _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Sports.NoAvailableEvents"))
                                    )
                                  ])
                                : _vm._e()
                            ])
                      ])
                    : _c(
                        "div",
                        { staticClass: "progress-circular" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isInPlayBoNode && _vm.selectedTab
            ? _c(
                "div",
                [
                  _c("live-coupon", {
                    attrs: {
                      isFlashBettingTab: _vm.isFlashBettingTab,
                      ontab: true,
                      idfosporttypescsv: _vm.selectedTab.csvparameters || "ALL",
                      maxeventspersporttype: _vm.selectedTab.maxitems,
                      couponname: _vm.selectedTab.name
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cfe090e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cfe090e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/tabCoupon.vue
// module id = null
// module chunks = 